// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Il","title":"Jl"};